import React from 'react';
import BJstandard from '../../../imgs/KII-Series.webp';
// import './Bjstandard.css';
import Reqprodcte from "../../../components/Reqprodcte";

const Kiiseries = () => {
    return (
        <div className="bjstand-container">
            {/* Left Side - Text */}
            <div className="bjstan-text"data-aos="flip-left">
                <h2 className="bj-texte-servi">High Precision Injection Molding Machine</h2>
                <h3 className="text-lg font-semibold text-color-dark text-gray-600">KII SERIES</h3>
                <p className="text-gray-600">
                    Powerjet New Series Hydraulic Injection Molding Machine With Faster Injection And Plasticizing Speed, More Stable And Higher Efficiency.
                </p>
                <ul className="clamp-1">
                    <li><strong>Clamping Force:</strong>  900~10000(KN)</li>
                    <li><strong>Driving System:</strong> Hydraulic</li>
                    <li><strong>Motor Type:</strong> Servo </li>
                    <li><strong>Applications:</strong> Food & Beverage Packaging, Necessities Products, Home Appliances, Electrical Components, Automotive Parts</li>
                </ul>
                <div className='stnd'>
                    <Reqprodcte />
                </div>
            </div>

            {/* Right Side - Image */}
            <div className="bjstan-img"data-aos="fade-down-left">
                <img
                    src={BJstandard}
                    alt="BJ Series Injection Molding Machine"
                    className="bjstan-imgs"
                />
            </div>
        </div>
    );
};

export default Kiiseries;
